import { Button } from 'react-aria-components'
import { ClearRefinements } from 'react-instantsearch'

const beforeGradient = `
  before:absolute
  before:top-[-31px]
  before:block
  before:w-full
  before:h-[30px]
  before:content-['']
  before:bg-gradient-to-t
  before:from-white
  before:to-transparent
`

export default function FilterModalFooter() {
  return (
    <footer
      className={`sticky bottom-0 left-0 z-10 border-t border-grey-300 bg-white px-l py-m m:px-m s:py-xs ${beforeGradient}`}>
      <div className="flex items-center justify-between">
        <ClearRefinements
          translations={{
            resetButtonText: 'Clear',
          }}
          classNames={{
            button:
              'text-17 ms:text-14 font-bold text-black hover:text-primary transition-colors cursor-pointer',
          }}
        />

        <Button slot="close" className="btn btn--solid btn--small ms:min-h-0 ms:p-xs ms:text-14">
          Show Results
        </Button>
      </div>
    </footer>
  )
}
